import PropTypes from 'prop-types';
import React, { Component } from "react";
export default class DogEar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      points: this.getPointSource(props.x),
      isOpen: false,
      x: props.x,
      isHover: props.isHover
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.x !== nextProps.x || this.state.isHover !== nextProps.isHover) {
      this.setState({ x: nextProps.x, points: this.getPointSource(nextProps.x, nextProps.isHover), isHover: nextProps.isHover });
    }
  }
  getPointSource(x, isHover = false) {
    let points = "";
    if (isHover) {
      points += `${x},1.0 ${x + 6.0},1.0 ${x + 6.0},7.0 ${x},7.0`;
    }
    else {
      points += `${x},1.0 ${x + 6.0},1.0 ${x},7.0`;
    }
    return points;
  }
  getDogEarContent() {
    return (
      <g transform={`translate(${this.state.x} -63.0)`}>
        <rect height={63} width={155} fill="yellow">
          <title>{this.props.text}</title>
        </rect>

      </g>);
  }
  handleMouseDown(show = false) {
    if (this.props.onShowDogEar) {
      if (show) {
        this.props.onShowDogEar({ x: this.state.x, text: this.props.text });
      }
      else {
        this.props.onShowDogEar();
      }

    }
  }
  render() {
    return (
      <g onMouseEnter={this.props.onMouseEnter} onMouseLeave={this.props.onMouseLeave}>
        <rect fillOpacity="0.0" x={this.state.x} y={1.0} height={8} width={8} />
        <polygon onMouseDown={() => this.handleMouseDown(true)} onMouseLeave={() => this.handleMouseDown()} className="dogear" points={this.state.points} />
      </g>
    );
  }
}
DogEar.propTypes = {
  x: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  onShowDogEar: PropTypes.func
};
